
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" allowClear  placeholder="搜索关键字"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="板块">
              <a-select v-model="queryParam.activity_id" placeholder="请选择"
                        allowClear >
                <a-select-option v-for="(option,index) in activityOptions" :value="option.id">{{option.title}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="授权编号">
                <a-input v-model="queryParam.kaojiregist_code" placeholder="搜索授权编号"/>
              </a-form-item>
            </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="单位名称">
              <a-input v-model="queryParam.danwei" placeholder="搜索单位名称"/>
            </a-form-item>
          </a-col>


          <a-col :md="6" :sm="24">
            <a-form-item label="考试时间">
              <a-range-picker
                      v-model="time_range_moment"
                      style="width: 100%"
                      format="YYYY-MM-DD HH:mm:ss"
                      :showTime="{
                defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                }"
              />
            </a-form-item>
          </a-col>

           </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px" v-if="false">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator" >
      <a-button type="primary" icon="plus" @click="addHandle" >新建</a-button>
    </div>

    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <span slot="name" slot-scope="text,record">
          <div style="margin-left: 10px; float: left">
            {{record.title}}
            <p style="color: #999">{{record.desc}}</p>
            <div style="height: 100px; overflow: hidden">
              <img :key="k" v-for="(pic,k) in record.pics_url" :src="pic" style="width: 100px ; margin-left: 10px" />
            </div>
            发布时间 {{record.create_time|timeFormat}}
          </div>
      </span>
      <span slot="rank" slot-scope="text,record">
        <template >
        <editable-cell :text="text" @change="onRankChange(record.id, 'rank', $event)"/>
        </template>
      </span>
      <span slot="action" slot-scope="text,record">
        <template >
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="onDelete(record)"  okText="确定" cancelText="取消">
            <a href="javascript:;">删除</a>
          </a-popconfirm>
          <a-divider type="vertical" />
          <a @click="handleCommentManage(record)">评论</a>
        </template>
      </span>
    </s-table>



    <a-modal
            title="操作"
            :width="1200"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="visible"
            @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form" >
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="标题"
                      hasFeedback
                >
                <a-input  v-decorator="[
              'title',
              {rules: []}
            ]"
                          placeholder="请输入标题"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">


                <a-form-item
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                        label="图片"
                        hasFeedback
                >
                  <pic-uploader
                          :numberLimit="1"
                          :file-list="formData.pics"
                  />
                </a-form-item>
              </a-col>

        </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="描述"
                      hasFeedback
              >
                <a-textarea  v-decorator="[
              'desc',
              {rules: []}
            ]"
                          placeholder="请输入描述"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">

                <a-form-item
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                        label="板块">
                  <a-select  :disabled="formData.id>0" v-model="formData.activity_id" placeholder="请选择"
                            allowClear >
                    <a-select-option v-for="(option,index) in activityOptions" :value="option.id">{{option.title}}</a-select-option>
                  </a-select>
                </a-form-item>
            </a-col>

          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="关闭评论"
                      hasFeedback
              ><r-switch  :formData="formData" field="can_comment" :checkedValue="2" :unCheckedValue="1"  checkedChildren="关闭评论" unCheckedChildren="支持评论" />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">

            </a-col>

          </a-row>

          <a-row :gutter="48">
            <a-col :md="48" :sm="24">
              <a-form-item
                      v-if="visible"
                      :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                      :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                      label="内容"
                      hasFeedback
              >
                <UEditor ref="ue" style=" height:520px;" :ueditorContent.sync="formData.content" ></UEditor>
              </a-form-item>
            </a-col>
          </a-row>

        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>



    <a-modal
            title="评论管理"
            :width="1000"
            style="top: 20px;"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="commentVisible"
            @ok="commentVisible=false"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-table :columns="commentColumns" :dataSource="kaojiCommentList" :pagination="commentPagination"
                   @change="handleCommentTableChange"
                   rowKey="id" :scroll="{ y: 300 }" bordered>
            <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }" class='custom-filter-dropdown'>
              <a-input
                      v-model="commentQuery.keywords"
                      placeholder="搜索姓名"
                      style="width: 188px; margin-bottom: 8px; display: block;"
              />
              <a-button
                      type='primary'
                      @click="commentSearch(selectedKeys, confirm)"
                      icon="search"
                      size="small"
                      style="width: 90px; margin-right: 8px"
              >搜索</a-button>
              <a-button
                      @click="commentSearchReset(selectedKeys, confirm)"
                      size="small"
                      style="width: 90px"
              >重置</a-button>
            </div>
            <span slot="name" slot-scope="text,record">
              {{record.user_name}}
            </span>
            <span slot="action" slot-scope="text,record">
              <template >
                <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="onCommentDelete(record)"  okText="确定" cancelText="取消">
                  <a href="javascript:;">删除</a>
                </a-popconfirm>
              </template>
            </span>
          </a-table>
        </a-form>
      </a-spin>
    </a-modal>


  </a-card>
  </template>

  <script>
  import STable from '@/components/table/'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import AInput from 'ant-design-vue/es/input/Input'
  import EditableCell from '@/components/EditableCell/'
  import UEditor from '@/components/UEditor/'
  import PicUploader from '@/components/PicUploader/'
  import FileUploader from '@/components/FileUploader/'
  import RSwitch from '@/components/RSwitch/'
  import areaOptions from '@/utils/area'
  import moment from 'moment'
  import 'moment/locale/zh-cn';
  moment.locale('zh-cn');

  import { getTopicList ,getTopicDetail,editTopic,getActivityList,addTopic,deleteTopic,setRank,getCommentList,deleteComment } from '@/api/topic'
  export default {
    name: 'KaojiSaiquList',
    components: {
      AInput,
      ATextarea,
      FileUploader,
      PicUploader,
      STable,
      RSwitch,
      UEditor,
      EditableCell,
    },
    data () {
      return {
        areaOptions,
        visible: false,
        saveLoading:false,
                subjectTypeOptions:[],
        formData:{
          id:0,
          activity_id:0,
          status:1,
          type:1,
          content:'',
          saidate_moment:null,
          saidate:'',
          time_range_moment:[],
          time_range:[],
          erweiimg:[],
          areas:[],
          pic:[],
          pics:[],
        },
        activityOptions:[],
        labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
          xs: { span: 24 },
          sm: { span: 8 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        form: this.$form.createForm(this),
        mdl: {},

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
          keywords:'',
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '50px'
          },
          {
            title: '名称',
            dataIndex: 'name',
            scopedSlots: { customRender: 'name' },
          },
          {
            title: '板块',
            dataIndex: 'activity_title',
          },
          {
            title: '排序',
            width:'150px',
            dataIndex: 'rank',
            scopedSlots: { customRender: 'rank' },
          },
          {
            title: '操作',
            dataIndex: 'action',
            width: 200,
            scopedSlots: { customRender: 'action' },
          }
        ],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          console.log('loadData');
          console.log(this.queryParam);
          let that= this;


          this.queryParam = Object.assign(this.queryParam,parameter);
          return getTopicList(this.queryParam)
            .then(res => {
              console.log('res');
              return res.data
            })
        },

        selectedRowKeys: [],
        selectedRows: [],
        commentVisible:false,

        //领取人员表头
        commentColumns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '100px'
          },
          {
            title: '用户名',
            dataIndex: 'user_name',
            width:'150px',
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'name',
            }
          },
          {
            title: '内容',
            width:'150px',
            dataIndex: 'content'
          },
          {
            title: '发布时间',
            width:'150px',
            dataIndex: 'create_time',
            customRender: (text) =>  {
              return moment(text*1000).format('YYYY-MM-DD HH:mm:ss');
            }
          },
          {
            title: '操作',
            dataIndex: 'action',
            width: 200,
            scopedSlots: { customRender: 'action' },
          }
        ],
        commentPagination:{
        },
        commentQuery:{
          kaoji_id:0,
          status:0,
          page:1,
          keywords:undefined
        },
        kaojiCommentList:[],
      }
    },
    computed:{
    },
    created(){
    },

    mounted(){
      let that = this;
      that.getActivityOptions();
    },
    methods: {
      moment,
      addHandle(){
        this.formData = {
          id:0,
          saidate:'',
          desc:'',
          can_comment:1,
          content:'',
          pic:[],
          pics:[],
        },
        this.form.resetFields();
        this.visible = true
      },
      handleCancel(){
        this.visible = false
      },
      getActivityOptions(){
        let that = this;
        getActivityList().then(res =>{
          that.activityOptions = res.data.list
        })
      },
      //展开关闭
      toggleAdvanced() {
        this.advanced = !this.advanced
      },
      handleEdit(record){
        let self = this
        this.visible = true
        getTopicDetail({ id: record.id }).then(res => {
          setTimeout(() =>{
            self.form.setFieldsValue({ ...res.data })
            self.formData.id = record.id;
            console.log('handleEdit')
            self.formData = { ...res.data };
          },200)
        })
        // console.log(this.mdl)
      },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false)
    },
      // 增改 处理
      handleOk(e) {
        let self = this;
        if(!self.formData.activity_id){
          self.$message.error('请选择板块');
          return ;
        }
        e.preventDefault()
        this.form.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            console.log('Received valuess of formData: ', self.formData)
            self.saveLoading = true;
            if(self.formData.id>0){
               editTopic({
                  id:self.formData.id,
                  title:values.title,
                  desc:values.desc,
                  content:self.formData.content,
                  pics:self.formData.pics,
                 can_comment:self.formData.can_comment,
                }).then(res => {
                  self.$message.success('修改成功')
                self.$refs.table.refresh(false)
                self.visible = false;
                self.saveLoading = false;
              }).catch(err =>{
                  self.$message.error(err.data.msg);
                self.saveLoading = false;
              })
            }else{
                addTopic({
                  activity_id:self.formData.activity_id,
                  title:values.title,
                  desc:values.desc,
                  content:self.formData.content,
                  pics:self.formData.pics,
                  can_comment:self.formData.can_comment,
                }).then(res => {
                  self.$message.success('修改成功')
                self.$refs.table.refresh(false)
                self.visible = false;
                self.saveLoading = false;
              }).catch(err =>{
                  self.$message.error(err.data.msg);
                self.saveLoading = false;
              })
            }

          }
        })
      },

      onDelete(record){
        let self = this;
          deleteTopic({
            id:record.id
          }).then(res => {
            self.$message.success('删除成功')
            self.$refs.table.refresh()
          }).catch(err =>{
            self.$message.error(err.data.msg);
          })
      },
      download(){
        getDownloadUrl(this.queryParam).then(res =>{
          console.log(res);
          window.open(res.data);
        })
      },
      onRankChange(key, dataIndex, value) {
        let self = this;
        setRank({
          id: key,
          rank:value
        }).then(res => {
          self.$refs.table.refresh(false)
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },


      handleCommentManage(record) {
        let self = this
        self.commentQuery.kaoji_id = record.id;
        self.commentQuery.keywords = undefined;
        self.commentQuery.status = undefined;
        self.commentPagination.page = 1;
        self.fetchCommentList();
        this.commentVisible = true
      },


      fetchCommentList(){
        let self = this
        getCommentList(Object.assign(self.commentQuery,self.commentPagination)).then(res => {
          self.kaojiCommentList = res.data.list
          self.commentPagination.total = res.data.total
        })
      },

      commentSearch(selectedKeys,confirm){
        let self = this
        confirm();
        self.fetchCommentList();
      },
      commentSearchReset(selectedKeys,confirm){
        let self = this;
        confirm();
        self.commentQuery.keywords = undefined;
        self.fetchCommentList();
      },
      handleCommentTableChange(pagination, filters, sorter) {
        console.log('filters',filters);
        let that = this;
        const pager = { ...this.pagination };
        pager.current = pagination.current;
        that.pagination = pager;
        that.commentQuery.page = pagination.current;
        that.fetchCommentList();
      },


      onCommentDelete(record){
        let self = this;
        deleteComment({
          id:record.id
        }).then(res => {
          self.$message.success('删除成功')
          self.fetchCommentList();
        }).catch(err =>{
          self.$message.error(err.data.msg);
        })
      },
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },

    },
    filters:{
    },
    watch: {
    }
  }
</script>
<style scoped>
  .custom-filter-dropdown {
    padding: 8px;
    border-radius: 4px;
    background: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .15);
  }

  .highlight {
    background-color: rgb(255, 192, 105);
    padding: 0px;
  }
</style>
